import type { RadioProps } from '@material-ui/core';

import { View, Radio as ZincRadioButton } from '@zinc/ui';
import { Text } from '@zinc/ui';
import type React from 'react';
import type { PropsWithChildren, ReactNode } from 'react';
interface IProps extends PropsWithChildren {
  disabled?: boolean;
  label?: React.ReactNode;
  value: any;
  onClick?: () => void;
  labelClassName?: string;
  name?: string;
}

function Radio(props: IProps & RadioProps) {
  const { disabled, label, name, value, labelClassName, onChange, checked, children, ...other } =
    props;
  return (
    <View
      as="label"
      borderColor={children ? 'neutral-faded' : undefined}
      borderRadius="medium"
      padding={children ? 4 : 2}
      shadow={children ? 'raised' : undefined}
    >
      <ZincRadioButton
        disabled={disabled}
        name={name ?? label ?? value}
        value={value}
        onChange={(value) => onChange?.(value.event, value.checked)}
        checked={checked}
      >
        <View paddingStart={2}>
          <Text weight={children ? 'medium' : 'regular'}>{label}</Text>
          {children}
        </View>
      </ZincRadioButton>
    </View>
  );
}

export default Radio;
